import { render, staticRenderFns } from "./blankCounter.vue?vue&type=template&id=35584e9e&"
import script from "./blankCounter.vue?vue&type=script&lang=ts&"
export * from "./blankCounter.vue?vue&type=script&lang=ts&"
import style0 from "./blankCounter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports